import { useTranslation } from "react-i18next";
import { AiOutlineSave } from "react-icons/ai";
import { HiMiniPencil } from "react-icons/hi2";
import { IoClose } from "react-icons/io5";
import { TailSpin } from "react-loader-spinner";
import { MutateOptions } from "@tanstack/react-query";
import { AxiosResponse } from "axios";

import { Patient } from "@customTypes/patient";

import { StyledCardHeader } from "./CardHeader.styled";

// type InitialFormDataStatesReset = (arg: string | Date | undefined) => void;
type InitialFormDataStatesReset = () => void;

interface CardHeaderProps {
  title: string;
  isUpdatePatientLoading: boolean;
  isCardEditable: boolean;
  setIsCardEditable: (arg: boolean) => void;
  isGetProfileLoading: boolean;
  formData: Patient;
  initialFormData: Patient;
  //* This is needed to re-initialize the dropdowns especially as they get stuck
  //* and cannot be changed after cancelling editing
  // todo: Investigate why this is happening
  // todo: Dropdowns have been changed now, check if this is still needed
  initialFormDataStatesResets?: InitialFormDataStatesReset[];
  setInitialFormData: (arg: Patient) => void;
  setFormData: (arg: Patient) => void;
  updatePatient: (
    variables: Patient,
    options?:
      | MutateOptions<AxiosResponse<any, any>, any, Patient, unknown>
      | undefined
  ) => void;
  hasErrors?: boolean;
}

export const CardHeader = ({
  title,
  isUpdatePatientLoading,
  isCardEditable,
  setIsCardEditable,
  isGetProfileLoading,
  formData,
  setFormData,
  setInitialFormData,
  initialFormData,
  updatePatient,
  initialFormDataStatesResets,
  hasErrors,
}: CardHeaderProps) => {
  const { t } = useTranslation();

  const renderIcon = () => {
    if (isUpdatePatientLoading || isGetProfileLoading)
      return (
        <TailSpin
          color="var(--clr-gray-300)"
          ariaLabel="Loading"
          wrapperClass="spinner"
        />
      );
    else if (isCardEditable) return <AiOutlineSave className="save-icon" />;
    else return <HiMiniPencil />;
  };

  return (
    <StyledCardHeader>
      <p className="title">{title}</p>
      <div className="btn-wrapper">
        <button
          disabled={isUpdatePatientLoading || hasErrors}
          onClick={() => {
            if (hasErrors) return;
            setIsCardEditable(!isCardEditable);
            if (isCardEditable) {
              updatePatient(formData, {
                onSuccess: () => {
                  setInitialFormData(formData);
                },
              });
            }
          }}
          title={isCardEditable ? t("save") : t("edit")}
          className={isCardEditable ? "move" : ""}>
          {renderIcon()}
        </button>
        <button
          disabled={isUpdatePatientLoading || hasErrors}
          onClick={() => {
            if (hasErrors) return;
            setIsCardEditable(false);
            setFormData(initialFormData);
            initialFormDataStatesResets?.length &&
              initialFormDataStatesResets.forEach(func => func());
          }}
          title={t("cancel")}
          className={!isCardEditable ? "disappear" : ""}>
          <IoClose className="close-icon" />
        </button>
      </div>
    </StyledCardHeader>
  );
};
